import React, { useState, useEffect } from 'react';
import { PaginationItem, PaginationLink, Pagination } from 'reactstrap';
import { range } from 'lodash';
import { useTranslation } from 'react-i18next';

const GeneratedPagination = ({ onClick, resetPagination, dataLength = 0, maxDataLength }) => {
  const { t } = useTranslation('common');
  const [currentPage, setCurrentPage] = useState(1);
  const [starter, setStarter] = useState(1);

  useEffect(() => {
    setCurrentPage(1);
    setStarter(1);
  }, [resetPagination]);

  const onPreviousArrow = () => {
    if (starter === 1) {
      return;
    }
    const newStarter = starter - 1;
    setStarter(newStarter);
    setCurrentPage(newStarter);
    onClick(newStarter);
  };

  const onNextArrow = () => {
    const newStarter = starter + 1;
    setStarter(newStarter);
    setCurrentPage(newStarter);
    onClick(newStarter);
  };

  return (
    <Pagination aria-label={t('Page navigation example')}>
      <PaginationItem key={'pre'} disabled={currentPage === 1}>
        <PaginationLink previous onClick={onPreviousArrow} disabled={currentPage === 1} />
      </PaginationItem>
      {range(starter, starter + 1).map((counter, index) => {
        return (
          <PaginationItem key={counter} active={counter === currentPage}>
            <PaginationLink
              onClick={() => {
                setCurrentPage(counter);
                onClick(counter);
              }}
            >
              {counter}
            </PaginationLink>
          </PaginationItem>
        );
      })}
      <PaginationItem key={'next'} disabled={dataLength < maxDataLength}>
        <PaginationLink next onClick={onNextArrow} disabled={dataLength < maxDataLength} />
      </PaginationItem>
    </Pagination>
  );
};

export { GeneratedPagination };
